import { Component, Vue, Prop } from 'vue-property-decorator';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapTheme } from '@/components/WorldMap/MapTheme';

@Component<WorldMap>({
  components: {
  },
})
export default class WorldMap extends Vue {
  @Prop()
  protected mapStyle?: string;

  @Prop({default: function () { return {lat:51.441643, lng: 5.469722} }})
  protected mapCenter?: MapCenter;

  @Prop({default: 2})
  protected mapZoom?: number;

  @Prop({default: 400})
  protected circleRadius?: number;
  
  protected mapOptions: any = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: true,
    styles: mapTheme,
  }
  // protected mapCircleOptions: any = {
  //   fillColor: this.getCircleFillColor(),
  //   strokeColor: '#20787d',
  //   strokeOpacity: 0.8,
  //   fillOpacity: 0.8,
  // }

  @Prop({default: function() { return [{
    center: {lat: 41.878, lng: -87.629},
    plays: 100000,
  }, {
    center: {lat: 40.714, lng: -74.005},
    plays: 120000,
  }, {
    center: {lat: 34.052, lng: -118.243},
    plays: 300000,
  }, {
    center: {lat: 49.25, lng: -123.1},
    plays: 200000,
  }, {
    center: {lat: 79.25, lng: -123.1},
    plays: 500000,
  }, {
    center: {lat: 49.25, lng: -123.1},
    plays: 400000,
  }, {
    center: {lat: 39.25, lng: -123.1},
    plays: 500000,
  }, {
    center: {lat: 40.712776, lng: -74.005974},
    plays: 900000,
  }, {
    center: {lat: 35.689487, lng: 139.691711},
    plays: 850000,
  }, {
    center: {lat: 53.551086, lng: 9.993682},
    plays: 750000,
  }, {
    center: {lat: 20.593683, lng: 78.962883},
    plays: 600000,
  }, {
    center: {lat: 55.755825, lng: 37.617298},
    plays: 650000,
  }, {
    center: {lat: 48.019573, lng: 66.923683},
    plays: 650000,
  }, {
    center: {lat: 62.108380, lng: 14.612746},
    plays: 180000,
  }, {
    center: {lat: -18.124971, lng: 25.251939},
    plays: 280000,
  }, {
    center: {lat: 70.023872, lng: 82.786052},
    plays: 220000,
  }, {
    center: {lat: 52.389011, lng: 28.766027},
    plays: 370000,
  }] }})
  protected markers?: any;
  protected showMapDialog: boolean = false;
  protected currentMarker: any = null;

  public mounted() {
    //
  }

  protected circleClicked(marker: any) {
    this.showMapDialog = true;
    this.currentMarker = marker;
    console.log('marker clicked', marker);
  }

  protected parseUnixToTime(unix: any) {
    const date = new Date(unix*1000);
    const minutes = "0" + date.getMinutes();
    const formattedTime = `${date.getHours()}:${minutes.substr(-2)}`;
    return formattedTime;
  }

  protected parseUnixToDate(unix: any) {
    const date = new Date(unix*1000);
    const formattedlDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    return formattedlDate;
  }

  protected getCircleOptions(marker: any) {
    const mapCircleOptions: any = {
      fillColor: this.getCircleFillColor(marker),
      strokeColor: this.getCircleStrokeColor(marker),
      strokeOpacity: 0.8,
      fillOpacity: 0.8,
    }

    return mapCircleOptions;
  }

  protected getCircleFillColor(marker: any) {
    if (marker.source === 'client') return '#4f8475';
    else if (marker.source === 'vr') return '#4f8475';
    else if (marker.source === 'ar') return '#4f8475';
    return '#20787d';
  }

  protected getCircleStrokeColor(marker: any) {
    if (marker.source === 'client') return '#186b50';
    else if (marker.source === 'vr') return '#186b50';
    else if (marker.source === 'ar') return '#186b50';
    return '#20787d';
  }
}

interface MapCenter {
  lat: number;
  lng: number;
}